import { render, staticRenderFns } from "./FlashCardAdmin.vue?vue&type=template&id=cb47f46a&scoped=true&"
import script from "./FlashCardAdmin.vue?vue&type=script&lang=js&"
export * from "./FlashCardAdmin.vue?vue&type=script&lang=js&"
import style0 from "./FlashCardAdmin.vue?vue&type=style&index=0&id=cb47f46a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb47f46a",
  null
  
)

export default component.exports